Object.defineProperty(exports, "__esModule", {
    value: true
});
var _object_spread = require("@swc/helpers/_/_object_spread");
//#region src/initContainerEntry.ts
function initContainerEntry(options) {
    var webpackRequire = options.webpackRequire, shareScope = options.shareScope, initScope = options.initScope, shareScopeKey = options.shareScopeKey, remoteEntryInitOptions = options.remoteEntryInitOptions;
    if (!webpackRequire.S) return;
    if (!webpackRequire.federation || !webpackRequire.federation.instance || !webpackRequire.federation.initOptions) return;
    var federationInstance = webpackRequire.federation.instance;
    federationInstance.initOptions(_object_spread._({
        name: webpackRequire.federation.initOptions.name,
        remotes: []
    }, remoteEntryInitOptions));
    var hostShareScopeKeys = remoteEntryInitOptions === null || remoteEntryInitOptions === void 0 ? void 0 : remoteEntryInitOptions.shareScopeKeys;
    var hostShareScopeMap = remoteEntryInitOptions === null || remoteEntryInitOptions === void 0 ? void 0 : remoteEntryInitOptions.shareScopeMap;
    if (!shareScopeKey || typeof shareScopeKey === "string") {
        var key = shareScopeKey || "default";
        if (Array.isArray(hostShareScopeKeys)) hostShareScopeKeys.forEach((hostKey)=>{
            if (!hostShareScopeMap[hostKey]) hostShareScopeMap[hostKey] = {};
            var sc = hostShareScopeMap[hostKey];
            federationInstance.initShareScopeMap(hostKey, sc, {
                hostShareScopeMap: (remoteEntryInitOptions === null || remoteEntryInitOptions === void 0 ? void 0 : remoteEntryInitOptions.shareScopeMap) || {}
            });
        });
        else federationInstance.initShareScopeMap(key, shareScope, {
            hostShareScopeMap: (remoteEntryInitOptions === null || remoteEntryInitOptions === void 0 ? void 0 : remoteEntryInitOptions.shareScopeMap) || {}
        });
    } else shareScopeKey.forEach((key)=>{
        if (!hostShareScopeKeys || !hostShareScopeMap) {
            federationInstance.initShareScopeMap(key, shareScope, {
                hostShareScopeMap: (remoteEntryInitOptions === null || remoteEntryInitOptions === void 0 ? void 0 : remoteEntryInitOptions.shareScopeMap) || {}
            });
            return;
        }
        if (!hostShareScopeMap[key]) hostShareScopeMap[key] = {};
        var sc = hostShareScopeMap[key];
        federationInstance.initShareScopeMap(key, sc, {
            hostShareScopeMap: (remoteEntryInitOptions === null || remoteEntryInitOptions === void 0 ? void 0 : remoteEntryInitOptions.shareScopeMap) || {}
        });
    });
    if (webpackRequire.federation.attachShareScopeMap) webpackRequire.federation.attachShareScopeMap(webpackRequire);
    if (typeof webpackRequire.federation.prefetch === "function") webpackRequire.federation.prefetch();
    if (!Array.isArray(shareScopeKey)) return webpackRequire.I(shareScopeKey || "default", initScope);
    if (Boolean(webpackRequire.federation.initOptions.shared)) return webpackRequire.I(shareScopeKey, initScope);
    return Promise.all(shareScopeKey.map((key)=>{
        return webpackRequire.I(key, initScope);
    })).then(()=>true);
}
//#endregion
exports.initContainerEntry = initContainerEntry; //# sourceMappingURL=initContainerEntry.cjs.map
